/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStateEnum } from './subscriptionStateEnum';
import { SubscriptionTypeEnumV2 } from './subscriptionTypeEnumV2';


export interface SubscriptionHistoryUpdatePatchSpec { 
    id: number;
    serial_number?: string;
    tenant_id?: string;
    sku?: string;
    quantity?: number;
    start_date?: string;
    end_date?: string;
    state?: SubscriptionStateEnum;
    effective_state?: SubscriptionStateEnum;
    effective_quantity?: number;
    incorta_subscription_id?: number;
    charge_id?: string;
    datacenter?: string;
    service_type?: string;
    sn_extension_date?: string;
    contract_nbr?: string;
    subscription_type?: SubscriptionTypeEnumV2;
}
export namespace SubscriptionHistoryUpdatePatchSpec {
}


